<template>
    <v-row>
        <v-col>
            <DynamicFormCore
                dynamicFormType="breath_tonometry"
                :answerableId="attendance.id"
                answerableType="Attendance"
            >
            </DynamicFormCore>
        </v-col>
    </v-row>
</template>

<script>
import DynamicFormCore from "@/components/dynamic_form/core.vue";
export default {
  name: "BreathTonometry",
  props: {
    attendance: Object,
  },
  components: {
    DynamicFormCore,
  },
}
</script>